/** @file Hierarchy row ids: a bone id, a slot id, or `<slot id>:<placeholder>` for a default-skin entry. */
import { ids } from '@pose2d/format/ids';
import type { Id } from '@pose2d/format/types';

/** What one hierarchy row stands for. */
export type HierarchyRow = { kind: 'bone'; id: Id } | { kind: 'slot'; id: Id } | { kind: 'placeholder'; slot: Id; placeholder: string };

/** Decodes a row id made by buildHierarchy (ids and names never contain ':'). */
export function parseRowId(row: string): HierarchyRow {
  const colon = row.indexOf(':');
  if (colon >= 0) return { kind: 'placeholder', slot: row.slice(0, colon), placeholder: row.slice(colon + 1) };
  return ids.prefixOf(row) === 'slot' ? { kind: 'slot', id: row } : { kind: 'bone', id: row };
}
